import { createSelector } from 'reselect'

import { selectSectionSettingsState } from './selectSectionSettingsState'

export const selectSectionSettings = createSelector(
  [selectSectionSettingsState],
  ({ settings }) => settings
)
